import React from 'react';
import { useSelector } from 'react-redux';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import StockMarketSVG from '../../../CommonComponents/OPL/illustrations/stock-market-horoscope.svg';
import { useDocumentTitle } from '../../../_hooks/useDocumentTitle';
import { selectCurrentClient } from '../../../CommonSelectors/CommonAreaSelector';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { StyledCard, Wrapper } from './WorkflowWelcome.styles';
import { WORKFLOW_ID_MAP } from './WorkflowWelcome.meta';

export const WorkflowWelcome = () => {
  useDocumentTitle('Start Workflow');

  const client = useSelector(selectCurrentClient);

  return (
    <Wrapper as="main">
      <StyledCard as="article">
        <StockMarketSVG width={278} style={{ margin: '0 auto' }} />
        <Text as="h1" fontWeight={600} fontSize="h4" mt="24" mb="8">
          Welcome {client.FirstName}!
        </Text>

        <Text as="p" color="neutral.500" fontWeight={500} mb="16">
          Your Financial Advisor invites you to assess your financial foundation so you can
          collaborate to create the best investment strategy for you. After you agree to the plan,
          you&apos;ll be able to track your progress on this site as well.
        </Text>

        <Text as="p" color="neutral.500" fontWeight={500}>
          Assessing your financial status shouldn&apos;t take more than{' '}
          <Text as="strong" fontWeight={600}>
            ~20 minutes
          </Text>{' '}
          to complete. Once you&apos;re done, your Advisor will contact you to discuss your goals
          and help you plan to reach them.
        </Text>

        <Button
          onClick={() =>
            ADV.util.Router.go2('Workflow', {
              clientId: ADV.data.user.Id,
              workflowId: WORKFLOW_ID_MAP[ADV.data.user.ConsumerAccessWorkflow],
              stepId: 0,
              pivotId: 0,
              pageId: 'start',
            })
          }
          mt="32"
        >
          Get Started
        </Button>
      </StyledCard>
    </Wrapper>
  );
};
